// extracted by mini-css-extract-plugin
export default {"main":"Methane_main__4vYUP"};